// EFAM checkout routing.
//
// Stripe Payment Links only - no backend, no server-side session creation.
// Keys are `${type}-${id}` where type is 'machine' or 'accessory' and id is
// the id in src/data/mock.js.
//
// LEAVE A VALUE EMPTY until the Payment Link for that SKU exists and has been
// checked. An empty value is safe: the button falls back to a prefilled
// WhatsApp order enquiry, so nothing is broken and no payment is taken.

import { contactInfo } from '../data/mock';

export const paymentLinks = {
  'machine-1': '',
  'machine-2': '',
  'machine-3': '',
  'machine-4': '',
  'machine-5': '',
  'machine-6': '',
  'machine-7': '',
  'machine-8': '',
  'machine-9': '',
  'machine-10': '',
  'machine-11': '',
  'machine-12': '',
  'machine-13': '',
  'machine-14': '',
  'machine-15': '',
  'machine-16': '',
  'machine-17': '',
  'machine-18': '',
  'machine-19': '',
  'machine-20': '',
  'machine-21': '',
  'machine-22': '',
  'machine-23': '',
  'machine-24': '',
  'accessory-1': '',
  'accessory-2': '',
  'accessory-3': ''
};

export const linkFor = (type, id) => {
  const url = paymentLinks[`${type}-${id}`];
  return url && url.startsWith('https://') ? url : null;
};

export const hasLink = (type, id) => Boolean(linkFor(type, id));

const enquiryUrl = (product) => {
  const text = encodeURIComponent(
    `Hi EFAM, I would like to order the ${product.name} (${product.price} AUD). ` +
    'Could you send me payment and delivery details please?'
  );
  return `${contactInfo.whatsappLink}?text=${text}`;
};

export const startCheckout = (product, type = 'machine') => {
  const url = linkFor(type, product.id);
  if (url) {
    window.location.href = url;
    return 'stripe';
  }
  window.open(enquiryUrl(product), '_blank', 'noopener,noreferrer');
  return 'enquiry';
};
